import TableBackgroundInfo from "./TableBackgroundInfo";
export default TableBackgroundInfo;
